<template>
  <div class="map-right-layers-item-service map-right-layers-item-service__container-component">
    <div
      v-if="state$$.isEditing"
      class="map-right-layers-item-service__form"
    >
      <div class="map-right-layers-item-service__form__row">
        <span class="p-float-label map-right-layers-item-service__form__row__input">
          <InputText
            id="url"
            v-model="v$.url.$model"
            type="text"
            :class="{
              'p-invalid': v$.url.$error
            }"
          />
          <label for="url">Url</label>
        </span>
      </div>
      <div class="map-right-layers-item-service__form__row">
        <span class="p-float-label map-right-layers-item-service__form__row__input">
          <InputText
            id="nombre_servicio"
            v-model="v$.nameService.$model"
            type="text"
            :class="{
              'p-invalid': v$.nameService.$error
            }"
          />
          <label for="nombre_servicio">Nombre del servicio</label>
        </span>
        <Dropdown
          v-model="v$.format.$model"
          class="map-right-layers-item-service__form__row__input"
          :options="protocoles"
          placeholder="Protocolo"
          :class="{
            'p-invalid': v$.format.$error
          }"
        />
      </div>
    </div>
    <div
      v-else
      class="map-right-layers-item-service__summary"
    >
      <div class="map-right-layers-item-service__summary__row">
        <div class="map-right-layers-item-service__summary__row__content">
          <strong>Url: </strong>
          <span>{{ v$.url.$model }}</span>
        </div>
      </div>
      <div class="map-right-layers-item-service__summary__row">
        <div class="map-right-layers-item-service__summary__row__content">
          <strong>Nombre del servicio: </strong>
          <span>{{ v$.nameService.$model }}</span>
        </div>
        <div class="map-right-layers-item-service__summary__row__content">
          <strong>Protocolo: </strong>
          <span>{{ v$.format.$model }}</span>
        </div>
      </div>
    </div>
    <div class="map-right-layers-item-service__buttons">
      <span
        v-if="state$$.isEditing"
        class="
          material-icons
          map-right-layers-item-service__buttons__button
          map-right-layers-item-service__buttons__button--green
        "
        @click="toggleIsEditing"
      >
        check
      </span>
      <span
        v-else
        class="
          material-icons
          map-right-layers-item-service__buttons__button
          map-right-layers-item-service__buttons__button--blue
        "
        @click="toggleIsEditing"
      >
        edit
      </span>
      <span
        class="
          material-icons
          map-right-layers-item-service__buttons__button
          map-right-layers-item-service__buttons__button--red
        "
        @click="() => emits('click-delete', state$$)"
      >
        delete_outline
      </span>
    </div>
  </div>
</template>


<script setup>
import {ref, reactive} from 'vue';

// Primevue
import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';

// config
import state from './map-right.layers.item-services.component-state';
import rules from './map-right.layers.item-services.rules';

// sttedra
import {useVuelidate} from '@sttedra_ui/framework';

// #region Props, Emits
const emits = defineEmits(['confirmed', 'click-delete']);

const props___ = defineProps({
  id: {
    type: String,
    default: null,
    required: true,
  },
});
// #endregion


// #region Params, Ref, Reactives, Computed
const state$$ = reactive({...state, id: props___.id});
const v$ = useVuelidate(rules, state$$);

const protocoles = ref([
  'WMS',
  'WMTS',
]);
// #endregion


// #region Functions
async function toggleIsEditing() {
  if (state$$.isEditing) {
    state$$.isValid = await v$.value.$validate();
    if (!state$$.isValid) {
      return;
    }
  }
  state$$.isEditing = !state$$.isEditing;
  if (!state$$.isEditing) {
    emits('confirmed', state$$);
  }
}
// #endregion


// #region Effects, Hooks
// ...
// #endregion


// #region Provide, Expose
defineExpose({
  ...state$$,
});
// #endregion
</script>


<style lang="scss" scoped>
.map-right-layers-item-service {
  &__container-component {
    display: flex;
    align-items: center;
    max-height: 300px;
    overflow: auto;
  }

  &__form {
    flex: 1 1 100%;
    display: flex;
    flex-direction: column;
    padding: 5px;

    &__row {
      flex: 1 1 100%;
      display: flex;

      &__input {
        flex: 1 1 100%;
        margin: 10px;

        & > * {
          width: 100%;
        }
      }
    }
  }

  &__summary {
    flex: 1 1 100%;
    display: flex;
    flex-direction: column;
    padding: 5px;

    &__row {
      flex: 1 1 100%;
      display: flex;

      &__content {
        flex: 1 1 100%;
        margin: 10px;

      }
    }
  }

  &__buttons {
    flex: 0 0 auto;
    padding: 5px;

    &__button {
      cursor: pointer;
      padding: 5px;

      &--red {
        color: $brand__color--red;
      }
      &--green {
        color: $brand__color--green;
      }
      &--blue {
        color: $brand__color--blue;
      }
    }
  }
}
</style>
